import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpXsrfTokenExtractor } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(private tokenExtractor: HttpXsrfTokenExtractor, private router: Router, private route: ActivatedRoute) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');
    const headers: { [key: string]: string } = {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json',
      // 'Content-Type': 'application/json'
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const XSRF_token = this.getCookie('XSRF-TOKEN');

    // Clone the request with credentials and headers
    const modifiedRequest = request.clone({
      withCredentials: true,
      setHeaders: {...headers,  ...(XSRF_token && { 'X-XSRF-TOKEN': XSRF_token }),
      'X-Requested-With': 'XMLHttpRequest',}
    });

    return next.handle(modifiedRequest).pipe(
      tap(
        () => {},
        (error) => {
          // console.error('Request error:', error);
        }
      )
    );
  }

  getCookie(name: string) {
    const cookies = document.cookie.split('; ');
    for (let cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name) return decodeURIComponent(value);
    }
    return null;
  }
}
